import { useSuspenseQuery } from '@tanstack/react-query';

import {
  type DuoSummaryKeyParams,
  getDuoSummaryKey,
  getDuoSummaryOptions,
} from './getDuoSummary.options';

export function useGetDuoSummary(params: DuoSummaryKeyParams) {
  return useSuspenseQuery(getDuoSummaryOptions(params));
}

useGetDuoSummary.getQueryKey = getDuoSummaryKey;
